import React, { useEffect } from "react";

export default function Size300X250({
  banner,
  title,
  titleButton,
  colorButton,
  colorTextButton,
  imageBrand,
  logoBrand,
  backgroundColorDetailsArea,
  borderRadiusButton,
}) {
  useEffect(() => {
    document.querySelector("#title").innerHTML = title;
  }, [title]);
  return (
    <>
      <div
        className="border border-1 d-flex flex-column justify-content-between position-relative"
        id="preview-banner"
        style={{
          width: `${banner.size.width}px`,
          height: `${banner.size.height}px`,
        }}
      >
        <div
          style={{
            width: `${banner.cropSize.width}px`,
            height: `${banner.cropSize.height}px`,
          }}
        >
          <img
            style={{
              width: `${banner.cropSize.width}px`,
              height: `${banner.cropSize.height}px`,
            }}
            src={
              imageBrand
                ? imageBrand
                : "/assets/img/preview-image-banner-generator.svg"
            }
          />
        </div>
        <div
          style={{
            width: `${banner.size.width - banner.cropSize.width}px`,
            height: `${banner.size.height - banner.cropSize.height}px`,
            backgroundColor: backgroundColorDetailsArea,
          }}
          className="d-flex flex-row justify-content-between align-items-center w-100 px-2"
        >
          <div id="title" className="w-100"></div>
          <div>
            <span
              className="btn btn-success px-2 py-1"
              id="view-button-in-preview-section"
              style={{
                backgroundColor: colorButton,
                borderColor: colorButton,
                borderRadius: `${borderRadiusButton}px`,
                color: colorTextButton,
              }}
            >
              {titleButton ? titleButton : "مشاهده"}
            </span>
          </div>
        </div>
        {logoBrand && (
          <span
            className="position-absolute"
            style={{
              top: banner.positionLogo.top + "px",
              left: banner.positionLogo.left + "px",
            }}
          >
            <img src={logoBrand} />
          </span>
        )}
      </div>
    </>
  );
}
